var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryGreenMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 49.878,
    viewBox: "0 0 56 49.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657",
    transform: "translate(472.203 -786.122)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Summary",
    transform: "translate(-472.203 832)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Summary")), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Activity",
    "data-name": "Iconly/Bulk/Activity",
    transform: "translate(-461.184 783.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34168",
    d: "M18.008,25.6H7.6a7.7,7.7,0,0,1-5.6-2.007A7.682,7.682,0,0,1,0,18.006V7.617a7.72,7.72,0,0,1,2.005-5.6A7.68,7.68,0,0,1,7.6,0h11.33a5.56,5.56,0,0,0-.1,1.05,5.73,5.73,0,0,0,5.728,5.719,5.89,5.89,0,0,0,1.038-.1V18.006a7.687,7.687,0,0,1-2,5.585A7.682,7.682,0,0,1,18.008,25.6ZM10.271,10.068a1.069,1.069,0,0,0-.14.009,1.053,1.053,0,0,0-.7.412l-4.2,5.419a1.036,1.036,0,0,0-.225.65,1.051,1.051,0,0,0,1.939.612l3.513-4.546,3.9,3.06a1.062,1.062,0,0,0,.66.232,1.054,1.054,0,0,0,.841-.42l4.064-5.244v-.026a1.066,1.066,0,0,0-.2-1.486,1.038,1.038,0,0,0-1.476.212l-3.426,4.408-3.9-3.072A1.055,1.055,0,0,0,10.271,10.068Z",
    transform: "translate(0 2.844)",
    fill: "#00ff5f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_742",
    cx: 3.555,
    cy: 3.555,
    r: 3.555,
    transform: "translate(21.333)",
    fill: "#00ff5f",
    opacity: 0.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryGreenMobile);
export default __webpack_public_path__ + "static/media/summary-green-mobile.84055225f05f7f98a49f2028e8b31b7d.svg";
export { ForwardRef as ReactComponent };